import { EntityDocumentsOrderBy } from '../../../../common/types/globalTypes';
import { OrderDirection, OrderLookup, SortOrder } from 'common/utils/commonTypes';

const orderByMap = new Map<string, OrderLookup>([
  [
    'documentTypes',
    {
      [OrderDirection.ASC]: [
        'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DOCUMENT_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
        'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DOCUMENT_TYPE_DESC',
      ],
    },
  ],
  [
    '_documentContents',
    {
      [OrderDirection.ASC]: ['_DOCUMENT_CONTENTS_ASC'],
      [OrderDirection.DESC]: ['_DOCUMENT_CONTENTS_DESC'],
    },
  ],
  [
    'comment',
    {
      [OrderDirection.ASC]: ['COMMENT_ASC'],
      [OrderDirection.DESC]: ['COMMENT_DESC'],
    },
  ],
  [
    'fileReference',
    {
      [OrderDirection.ASC]: ['FILE_REFERENCE_ASC'],
      [OrderDirection.DESC]: ['FILE_REFERENCE_DESC'],
    },
  ],
  [
    '_createdDate',
    {
      [OrderDirection.ASC]: ['_CREATED_DATE_ASC'],
      [OrderDirection.DESC]: ['_CREATED_DATE_DESC'],
    },
  ],
  [
    '_sharedByUser',
    {
      [OrderDirection.ASC]: ['_SHARED_BY_USER_ASC'],
      [OrderDirection.DESC]: ['_SHARED_BY_USER_DESC'],
    },
  ],
]);

export const toReportOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: EntityDocumentsOrderBy[] = [
    '_CREATED_DATE_DESC',
    'PRIMARY_KEY_ASC',
  ];
  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ? orderBy : []), ...orderByArray];
};
